export enum CaffeinatedProductType {
    None = 0,
    CaffeinatedEnergyDrink = 1,
    NonCarbonatedBeverages = 2,
    CarbonatedBeverages = 4,
    ChocolateConfectionaries = 8,
    ProteinIsolateAndCerealBars = 16,
    ChewingGum = 32
  }